<template>
  <div v-if="displayItemList.length !== 0">
    <div class="ticket-area">
      <p class="section-title">
        <img src="@/assets/coupon.svg" />
        クーポン
      </p>
      <ul class="ticket-list">
        <ListItem
          v-for="item in displayItemList"
          :ticketItem="item"
          :key="item.id"
          :current="current"
        />
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ListItem from "@/components/Tickets/ListItem";
import { TICKET_INTERVAL } from "../../const.js";

export default {
  name: "ticket-area",
  components: {
    ListItem,
  },
  props: {
    ticketList: { type: Array, require: true },
    distance: { type: Number, require: true },
    current: { type: String, default: false, required: true },
  },
  computed: {
    ...mapState(["selectedSpotTicketData", "registrationId"]),
    currentTicketData() {
      if (this.current === "RouteSearch") {
        return this.selectedSpotTicketData.dropspot;
      } else if (this.current === "MyPage") {
        return this.selectedSpotTicketData.mypage;
      } else if (this.current === "JyutaiSearch") {
        return this.selectedSpotTicketData.jyutai;
      }
    },
    formattedCurrentDate() {
      const formattedCurrentDate = this.formatDateToCalc(new Date());
      return formattedCurrentDate;
    },
    displayItemList() {
      // 表示条件
      // 1. 自分が有効期間内に利用したアイテム（使用済み）
      // 2. 利用残数があるアイテム（未利用）

      if (this.currentTicketData === undefined) return [];

      // 利用可能残があるかどうか
      return this.ticketList.filter((item) => {
        const ticketRemain =
          this.currentTicketData.filter((ticket) => {
            if (ticket.TicketId !== item.id) return false;

            const formattedTargetDate = this.formatDateToCalc(
              new Date(ticket.CreatedAt),
            );
            return (
              this.formattedCurrentDate - formattedTargetDate < TICKET_INTERVAL
            );
          }).length < item.number;

        // 有効期間中に自分が利用したものかどうか
        const myTicket =
          this.currentTicketData.filter((ticket) => {
            if (ticket.TicketId !== item.id) return false;
            if (ticket.RegistrationAutoId !== this.registrationId) return false;

            const formattedTargetDate = this.formatDateToCalc(
              new Date(ticket.CreatedAt),
            );

            if (
              !(
                this.formattedCurrentDate - formattedTargetDate <
                TICKET_INTERVAL
              )
            )
              return false;

            return true;
          }).length !== 0;

        return ticketRemain || myTicket;
      });
    },
  },
  methods: {
    formatDateToCalc(dt) {
      var y = String(dt.getFullYear());
      var m = String(("00" + (dt.getMonth() + 1)).slice(-2));
      var d = String(("00" + dt.getDate()).slice(-2));

      return Number(`${y}${m}${d}`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";

.ticket-area {
  margin: 2rem 0;
  padding: 0 1.25rem;
  .section-title {
    display: flex;
    align-items: center;
    margin: 0.5rem 0;
    img {
      margin-right: 0.5rem;
      width: 20px;
    }
    p {
      line-height: 20px;
    }
  }
  .ticket-list {
    list-style: none;
    padding-left: 0;
    border-bottom: 1px #e7e7e7 solid;
    margin: 0.5rem 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DropSpotSelectModal/TicketArea.vue